/**
 * Loyalty discount from previous booked trips (exact mobile_no match).
 * Thresholds / percents come from REACT_APP_* env (defaults match product rules).
 */

function envNumber(name, fallback) {
  const raw = process.env[name];
  if (raw == null || !String(raw).trim()) return fallback;
  const n = Number(String(raw).trim());
  return Number.isFinite(n) ? n : fallback;
}

/** Digits only length (ignores + and spaces). */
export function countMobileDigits(mobile) {
  return String(mobile || "").replace(/\D/g, "").length;
}

export const LOYALTY_LOOKUP_MIN_DIGITS = envNumber(
  "REACT_APP_LOYALTY_LOOKUP_MIN_DIGITS",
  10,
);

/** Tier: at least N prior booked trips → percent off total. Highest matching tier wins. */
export function getLoyaltyDiscountTiers() {
  return [
    {
      minBookings: envNumber("REACT_APP_LOYALTY_TIER1_MIN_BOOKINGS", 5),
      percent: envNumber("REACT_APP_LOYALTY_TIER1_DISCOUNT_PERCENT", 2.5),
    },
    {
      minBookings: envNumber("REACT_APP_LOYALTY_TIER2_MIN_BOOKINGS", 10),
      percent: envNumber("REACT_APP_LOYALTY_TIER2_DISCOUNT_PERCENT", 5),
    },
    {
      // "more than 20" → min 21
      minBookings: envNumber("REACT_APP_LOYALTY_TIER3_MIN_BOOKINGS", 21),
      percent: envNumber("REACT_APP_LOYALTY_TIER3_DISCOUNT_PERCENT", 7.5),
    },
  ].sort((a, b) => a.minBookings - b.minBookings);
}

/**
 * @param {number} previousBookedCount
 * @returns {{ percent: number, minBookings: number } | null}
 */
export function resolveLoyaltyDiscount(previousBookedCount) {
  const count = Math.max(0, Number(previousBookedCount) || 0);
  let best = null;
  for (const tier of getLoyaltyDiscountTiers()) {
    if (count >= tier.minBookings) best = tier;
  }
  return best;
}

/**
 * @param {number} subtotalLkr
 * @param {number} previousBookedCount
 */
export function applyLoyaltyDiscount(subtotalLkr, previousBookedCount) {
  const subtotal = Math.max(0, Number(subtotalLkr) || 0);
  const tier = resolveLoyaltyDiscount(previousBookedCount);
  if (!tier || tier.percent <= 0 || subtotal <= 0) {
    return {
      subtotal,
      discountPercent: 0,
      discountAmount: 0,
      total: Math.round(subtotal),
      previousBookedCount: Math.max(0, Number(previousBookedCount) || 0),
      tierMinBookings: 0,
    };
  }
  const discountAmount = Math.round((subtotal * tier.percent) / 100);
  const total = Math.max(0, Math.round(subtotal) - discountAmount);
  return {
    subtotal: Math.round(subtotal),
    discountPercent: tier.percent,
    discountAmount,
    total,
    previousBookedCount: Math.max(0, Number(previousBookedCount) || 0),
    tierMinBookings: tier.minBookings,
  };
}
